import { render } from "./SaveAndContinue.vue?vue&type=template&id=ff831a26&scoped=true&ts=true"
import script from "./SaveAndContinue.vue?vue&type=script&lang=ts"
export * from "./SaveAndContinue.vue?vue&type=script&lang=ts"

import "./SaveAndContinue.vue?vue&type=style&index=0&id=ff831a26&scoped=true&lang=css"

import exportComponent from "/home3/sli/web/public/resources/editorvue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff831a26"]])

export default __exports__